export const CDN_PUBLIC_IMAGES_URL =
  'https://cdn-public-images.economybookings.com'
